import { Col, Form, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetPortofolioFilter } from "../ClientSideStates";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import Search from "./Search";
import StatusTabFilters from "./StatusTabsFilter";

const TopFilters = () => {
  const { filter } = useSelector((state: RootState) => state.portofolio);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const handleChangeStore = (value: string) => {
    const currentFilter = { ...filter };
    if (value) {
      currentFilter["Status"] = value;
    } else {
      delete currentFilter["Status"];
    }
    dispatch(handleSetPortofolioFilter({ filter: currentFilter }));
  };
  const status = [
    { label: "Taslak", value: 0 },
    { label: "Onay Bekliyor", value: 1 },
    { label: "Yayında", value: 2 },
    { label: "Süresi Doldu", value: 3 },
    { label: "Kullanıcı Tarafından Yayından Kaldırıldı/Pasife Alındı", value: 4 },
    { label: "Yönetici Tarafından Reddedildi", value: 6 },
    { label: "Yönetici Tarafından Yayından Kaldırıldı/Pasife Alındı", value: 7 },
    { label: "Satıldı", value: 8 },
  ];
  return (
    <Form form={form}>
      <Row gutter={[20,20]}>
        <Col xs={24} >
          <StatusTabFilters/>
        </Col>
        {/* <MazakaSelect
          allowClear
          xs={24}
          md={12}
          lg={6}
          options={status}
          name={"Status"}
          size="large"
          placeholder="Durum"
          onChange={handleChangeStore}
        /> */}
        <Col
         xs={24}
         md={12}
         lg={6}
        >
        <Search/>
        </Col>
      </Row>
    </Form>
  );
};

export default TopFilters;
